import { Link } from 'react-router-dom'
import { SITE } from '@/lib/site'
import { Logo } from './Logo'
import { openMeasurementSettings } from '@/lib/measurement'

const COLUMNS = [
  {
    title: 'Site',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Consultar', to: '/#consultar' },
      { label: 'Minhas consultas', to: '/minhas-consultas' },
      { label: 'Já paguei', to: '/ja-paguei' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Termos de uso', to: '/termos' },
      { label: 'Política de privacidade', to: '/privacidade' },
    ],
  },
  {
    title: 'Serviços',
    links: [
      { label: 'Consulta pela placa', to: '/#consultar' },
      { label: 'Débitos e restrições', to: '/#o-que-voce-descobre' },
      { label: 'Leilão e sinistro', to: '/#o-que-voce-descobre' },
      { label: 'Proprietário e Renavam', to: '/#o-que-voce-descobre' },
    ],
  },
]

/** Rodapé preto: o ícone da marca se funde ao fundo e a roda vermelha fica solta. */
export function SiteFooter() {
  return (
    <footer className="mt-20 border-t-4 border-brand-logo bg-ink text-white">
      <div className="mx-auto w-full max-w-6xl px-4 py-12">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <Logo variant="icon" className="-mt-4 -ml-3.5 size-20" />
            <p className="mt-1 max-w-xs text-sm text-white/70">
              {SITE.footerClaim}
            </p>
          </div>

          {COLUMNS.map((column) => (
            <nav key={column.title} aria-label={column.title}>
              <h3 className="eyebrow text-white">{column.title}</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-white/70">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="hover:text-brand-logo">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <nav aria-label="Redes sociais">
            <h3 className="eyebrow text-white">Redes sociais</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-white/70">
              {SITE.social.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-brand-logo"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 border-t border-white/15 pt-6 text-xs text-white/60">
          <button type="button" onClick={openMeasurementSettings} className="mb-4 underline hover:text-white">Preferências de cookies</button>
          {/*
            Razão social e CNPJ ficam como campos a preencher: quando a empresa
            existir, SITE.legalName e SITE.cnpj entram no lugar do aviso.
          */}
          <p>
            {SITE.legalName && SITE.cnpj
              ? `${SITE.legalName} — CNPJ ${SITE.cnpj}`
              : SITE.legalNotice}
          </p>
          <p className="mt-2">
            {SITE.name} — suporte em{' '}
            <a href={`mailto:${SITE.supportEmail}`} className="hover:text-brand-logo">
              {SITE.supportEmail}
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
